import { render } from "./WhiteFooter.vue?vue&type=template&id=36db2f5c&scoped=true"
import script from "./WhiteFooter.vue?vue&type=script&lang=js"
export * from "./WhiteFooter.vue?vue&type=script&lang=js"

import "./WhiteFooter.vue?vue&type=style&index=0&id=36db2f5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36db2f5c"]])

export default __exports__